import { render, staticRenderFns } from "./AdministratorDiagnosticTestDataUpload.vue?vue&type=template&id=415e26f5&scoped=true&"
import script from "./AdministratorDiagnosticTestDataUpload.vue?vue&type=script&lang=js&"
export * from "./AdministratorDiagnosticTestDataUpload.vue?vue&type=script&lang=js&"
import style0 from "./AdministratorDiagnosticTestDataUpload.vue?vue&type=style&index=0&id=415e26f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415e26f5",
  null
  
)

export default component.exports